export default __webpack_public_path__ + "static/media/bg_coming_soon.46efaf08.png";